<template>
  <div id="epaReport" :class="{'sidebar-active': sidebarActive}">
    <!-- Loader -->
    <loader v-if="!isRender || loaderActive"></loader>

    <div class="sidebar-wrap">
      <epa-sidebar ref="leftSidebar"
                    v-if="isRender"
                    v-model="leftSideBarData"
                    :sidebarActive="sidebarActive"
                   @setCondition="setCondition"
      >
      </epa-sidebar>
      <div v-if="sidebarActive" class="sidebar-overlay hidden-lg" @click="sidebarActive = false"></div>
    </div>
    <!-- 사업성 검토 영역 -->
    <div class="preview-wrap">
      <div class="container preview-content">
        <div class="row">
          <div :class="headerClass">
            <div class="title-box">
              <div class="sub-title margin-bottom-8">
                <span v-if="data.updated" class="date-tag">{{ data.updated | nullCheck | formatDate }} 저장</span>
              </div>
              <div class="header-title">
                <!-- 프로젝트명 수정 영역 -->
                <div v-show="titleEdit" class="title-edit-box">
                  <input type="text"
                         maxlength="40"
                         class="hz-input-default hz-input-md project-title"
                         style="width: calc(100% - 56px);"
                         v-model="data.name">
                  <button type="submit"
                          class="hz-btn-default hz-btn-md"
                          style="width: 40px; float: left; border-left: none; border-color: #ced4da; box-shadow: none;"
                          @click.prevent="titleEdit = false">완료</button>
                </div>
                <div v-show="!titleEdit" class="title-edit-box">
                  <p class="project-title" style="max-width: calc(100% - 48px); margin-right: 8px;">{{ data.name | nullCheck }}</p>
                  <i class="glyphicon glyphicon-pencil" @click="titleEdit = true"></i>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button v-if="isNewReport || hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg pull-right" style="width: 140px; margin-left: 8px;" @click.prevent="showSaveModal('save')">저장 후 미리보기</button>
            </div>
          </div>
          <div :class="bodyClass">
            <!-- 전력사용패턴 -->
            <section id="pattern">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="squarebullet">수요관리 분석결과</h4>
                  </div>
                </div>
                <h5 class="subtitle">참여조건 검토 (RRMSE 검증)</h5>
                <div class="card-content margin-bottom-24">
                  <table class="col-xs-12 margin-bottom-24">
                    <tr class="table-header">
                      <th class="bg-light-gray" colspan="3">평일 시간대별 사용량(kWh)</th>
                      <th class="bg-light-gray" colspan="3">수요감축 발령가능 시간대 평균 전력량(kWh)</th>
                    </tr>
                    <tr class="table-header">
                      <th class="bg-light-gray" style="font-weight: normal;">최대값</th>
                      <th class="bg-light-gray" style="font-weight: normal;">평균값</th>
                      <th class="bg-light-gray" style="font-weight: normal;">최소값</th>
                      <th class="bg-light-gray" style="font-weight: normal;">평일 최대값</th>
                      <th class="bg-light-gray" style="font-weight: normal;">평일 평균값</th>
                      <th class="bg-light-gray" style="font-weight: normal;">평일 최소값</th>
                    </tr>
                    <tr class="table-content">
                      <td>{{ numberToCommaStr(data.workingDayHourUsage.max) }}</td>
                      <td>{{ numberToCommaStr(data.workingDayHourUsage.avg) }}</td>
                      <td>{{ numberToCommaStr(data.workingDayHourUsage.min) }}</td>
                      <td>{{ numberToCommaStr(data.drWorkingDayHourUsage.max) }}</td>
                      <td>{{ numberToCommaStr(data.drWorkingDayHourUsage.avg) }}</td>
                      <td>{{ numberToCommaStr(data.drWorkingDayHourUsage.min) }}</td>
                    </tr>
                  </table>
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th class="bg-light-gray" colspan="3">RRMSE 검증</th>
                    </tr>
                    <tr class="table-header">
                      <th class="bg-light-gray" style="font-weight: normal;">Max(4/5)</th>
                      <th class="bg-light-gray" style="font-weight: normal;">Mid(6/10)</th>
                      <th class="bg-light-gray" style="font-weight: normal;">결과</th>
                    </tr>
                    <tr class="table-content">
                      <td>{{ data.rrmse.max45 }}%</td>
                      <td>{{ data.rrmse.mid610 }}%</td>
                      <td style="color: #ff7133;">{{ data.rrmse.result }}</td>
                    </tr>
                  </table>
                </div>
                <div class="card-content margin-bottom-24">
                  <div id="elecUsagePatternChart" ref="elecUsagePatternChart" class="chart"></div>
                </div>
                <div class="card-content">
                  <p style="float: right; font-size: 11px; margin-bottom: 3px;">(단위: kWh)</p>
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th class="bg-light-gray">시간</th>
                      <th class="bg-light-blue">1</th>
                      <th class="bg-light-blue">2</th>
                      <th class="bg-light-blue">3</th>
                      <th class="bg-light-blue">4</th>
                      <th class="bg-light-blue">5</th>
                      <th class="bg-light-blue">6</th>
                      <th class="bg-light-blue">7</th>
                      <th class="bg-light-blue">8</th>
                      <th class="bg-light-blue">9</th>
                      <th class="bg-light-red">10</th>
                      <th class="bg-light-red">11</th>
                      <th class="bg-light-red">12</th>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 최대값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour <= 12 })">
                          {{ numberToCommaStr(usage.max) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 평균값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour <= 12 })">
                          {{ numberToCommaStr(usage.avg) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 최소값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour <= 12 })">
                          {{ numberToCommaStr(usage.min) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                    <tr class="table-header">
                      <th class="bg-light-gray">시간</th>
                      <th class="bg-light-blue">13</th>
                      <th class="bg-light-red">14</th>
                      <th class="bg-light-red">15</th>
                      <th class="bg-light-red">16</th>
                      <th class="bg-light-red">17</th>
                      <th class="bg-light-red">18</th>
                      <th class="bg-light-red">19</th>
                      <th class="bg-light-red">20</th>
                      <th class="bg-light-blue">21</th>
                      <th class="bg-light-blue">22</th>
                      <th class="bg-light-blue">23</th>
                      <th class="bg-light-blue">24</th>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 최대값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour > 12 })">
                          {{ numberToCommaStr(usage.max) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 평균값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour > 12 })">
                          {{ numberToCommaStr(usage.avg) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                    <tr class="table-content">
                      <td class="bg-light-gray">
                        평일 최소값
                      </td>
                      <template v-if="data.usage_by_hour && data.usage_by_hour.length > 0">
                        <td v-for="usage in data.usage_by_hour.filter((usage) => { return usage.hour > 12 })">
                          {{ numberToCommaStr(usage.min) }}
                        </td>
                      </template>
                      <template v-else>
                        <td v-for="item in 12">
                          -
                        </td>
                      </template>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 예상수익 -->
            <section id="expectedProfit">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="squarebullet">예상수익</h4>
                  </div>
                </div>
                <div class="card-content margin-bottom-48">
                  <p style="float: right; font-size: 11px; margin-bottom: 3px;">(단위: 원)</p>
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th class="bg-light-gray">의무감축 DR: 기본 정산금</th>
                      <th class="bg-light-gray">자발적 DR: 차등 정산금</th>
                      <th class="bg-light-gray font-weight-bold" style="color: #40678F;">합계</th>
                    </tr>
                    <tr class="table-content">
                      <td>
                        {{ numberToCommaStr(data.expectedProfit.base) }}
                      </td>
                      <td>
                        {{ numberToCommaStr(data.expectedProfit.performance) }}
                      </td>
                      <td class="font-weight-bold" style="color: #40678F;">
                        {{ numberToCommaStr(data.expectedProfit.sum) }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="have-child row margin-bottom-48">
                  <div class="col-md-12 col-xs-12">
                    <div class="row">
                      <div class="col-xs-6 profit-box">
                        <div class="have-child" style="background-color: #f7f9fa;">
                          <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                            예상 용량
                          </div>
                          <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                            <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                              {{ numberToCommaStr(data.dr_capacity) }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;">kW</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-6 profit-box">
                        <div class="have-child" style="background-color: #f7f9fa;">
                          <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                            예상 정산금
                          </div>
                          <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                            <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                              {{ numberToCommaStr(data.expectedProfit.sum) }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;">원/연</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-content">
                  <table class="col-xs-12">
                    <tr class="table-header">
                      <th class="bg-light-gray">범위</th>
                      <th class="bg-light-gray">연간 전력낙찰량(kWh)</th>
                      <th class="bg-light-gray">연간 예상 정산금(원)</th>
                      <th class="bg-light-gray">참고</th>
                    </tr>
                    <tr class="table-content">
                      <td>최대</td>
                      <td>{{ numberToCommaStr(data.bid.maxFilled.toFixed(0)) }}</td>
                      <td>{{ numberToCommaStr(data.bid.maxProfit.toFixed(0)) }}</td>
                      <td>낙찰률 100%</td>
                    </tr>
                    <tr class="table-content">
                      <td>최소</td>
                      <td>{{ numberToCommaStr(data.bid.minFilled.toFixed(0)) }}</td>
                      <td>{{ numberToCommaStr(data.bid.minProfit.toFixed(0)) }}</td>
                      <td>낙찰률 {{ numberToCommaStr(data.dr_winning_rate) }}%</td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>
            <!-- 예상 절감효과 -->
            <section id="expectedReduction">
              <div class="card-wrap margin-bottom-48">
                <div class="card-header">
                  <div class="card-title">
                    <h4 class="squarebullet">예상 절감효과</h4>
                  </div>
                </div>
                <div class="card-content">
                  <div class="have-child row">
                    <h5 class="subtitle">A.한전 계약 정보</h5>
                    <div class="col-md-12 col-xs-12 margin-bottom-32">
                      <div class="row">
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              현재 요금제
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.customer_info && data.customer_info.plan && data.customer_info.plan.name ? data.customer_info.plan.name : '' }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              계약전력
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.customer_info ? numberToCommaStr(data.customer_info.contract_power) : '' }}
                                <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;">kW</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="subtitle">B.기본요금 정보</h5>
                    <div class="col-md-12 col-xs-12 margin-bottom-32">
                      <div class="row">
                        <div class="col-xs-4 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                               요금적용전력
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.customer_info ? numberToCommaStr(data.customer_info.charge_peak) : '' }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">kW</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-4 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              기본요금 단가
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ? numberToCommaStr(data.customer_info.plan.baseCharge) : '' }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">원/kW</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-4 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              월별 기본요금
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ? numberToCommaStr(data.customer_info.charge_peak * data.customer_info.plan.baseCharge) : '' }}  <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">원/연</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="subtitle">C.목표값</h5>
                    <div class="col-md-12 col-xs-12 margin-bottom-32">
                      <div class="row">
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              목표전력 설정
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ numberToCommaStr(data.target_peak) }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">kW</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              목표 기본요금
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{ data.target_peak && data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ? numberToCommaStr(data.target_peak * data.customer_info.plan.baseCharge) : '' }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">원/월</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <h5 class="subtitle">D.절감효과</h5>
                    <div class="col-md-12 col-xs-12 margin-bottom-32">
                      <div class="row">
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              절감액
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{
                                data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ?
                                numberToCommaStr((data.customer_info.charge_peak * data.customer_info.plan.baseCharge -
                                data.target_peak * data.customer_info.plan.baseCharge))
                                :
                                ''
                                }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">원/월</span>
                              </div>
                              <div class="font-size-24 font-weight-bold" style="color: #26507a;">
                                {{
                                  data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ?
                                    numberToCommaStr((data.customer_info.charge_peak * data.customer_info.plan.baseCharge -
                                    data.target_peak * data.customer_info.plan.baseCharge) * 12)
                                    :
                                    ''
                                }} <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">원/연</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-xs-6 profit-box">
                          <div class="have-child" style="background-color: #f7f9fa;">
                            <div class="font-size-14 text-align-center margin-top-32" style="color: #343a40;">
                              절감율
                            </div>
                            <div class="yield text-align-center col-xs-12 margin-top-32 margin-bottom-32">
                              <div class="font-size-24 flexitem font-weight-bold" style="color: #26507a;">
                                {{
                                  data.customer_info && data.customer_info.plan && data.customer_info.plan.baseCharge ?
                                    numberToCommaStr((((data.customer_info.charge_peak * data.customer_info.plan.baseCharge - data.target_peak * data.customer_info.plan.baseCharge) / (data.customer_info.charge_peak * data.customer_info.plan.baseCharge)) * 100))
                                    :
                                    ''
                                }}
                                <span style="display: inline-block; position: relative;  color: #495057; font-size: 12px; font-weight: normal;"">%</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 class="subtitle">E. 피크전력 그래프</h5>
                  <div id="peakElecChart" ref="peakElecChart" class="chart"></div>
                </div>
              </div>
            </section>
          </div>
          <div class="preview-footer">
            <div class="row">
              <div class="col-xs-12 text-center">
                <button class="hz-btn-primary hz-btn-lg" type="button" @click.prevent="showSaveModal('save')">저장 후 미리보기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- API 요청 상태 알림창 -->

    <!-- 문의하기 버튼 -->
    <div class="contact-fab">
      <a class="fab fab-text" @click.prevent="showContactModal">문의<br>하기</a>
    </div>

    <!-- 문의하기창 -->
    <contact-modal ref="contactModal" :contactMessage="contactMessage"></contact-modal>

    <!-- 쿠폰받기 알림창 -->
    <modal ref="couponModal" :id="couponModal.id" :type="couponModal.type" :title="couponModal.title"
           :size="couponModal.size" :fields="couponModal.fields" @submit="$router.push({name: 'notice', query: {title: '무료 쿠폰'}})"></modal>

    <!-- 이용권 확인 알림창 -->
    <modal ref="pricingModal" :id="pricingModal.id" :type="pricingModal.type" :title="pricingModal.title"
           :size="pricingModal.size" :fields="pricingModal.fields" @submit="$router.push('/pricing')"></modal>

    <!-- 보고서 저장 알림창 -->
    <modal ref="saveModal" :id="saveModal.id" :type="saveModal.type" :title="saveModal.title"
           :size="saveModal.size" :fields="saveModal.fields" @submit="submitReport()" v-model="data"></modal>

    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>
  </div>
</template>

<script>
import Loader from 'common/components/Loader'
import InputField from 'common/components/InputText'
import Tooltip from 'common/components/Tooltip'
import Modal from 'common/components/Modal'
import BarLoader from 'common/components/BarLoader'
import GenerateTimeChart from '@/components/chart/GenerateTimeChart'
import SimulationTimeChart from '@/components/chart/SimulationTimeChart'
import MonthYieldChart from '@/components/chart/MonthYieldChart'
import ProfitChart from '@/components/chart/ProfitChart'
import ContactModal from '@/components/ContactModal'
import Alert from '@/components/Alert'
import api from '@/api/index'
import eventHub from '@/shared/EventHub'
import { mapActions, mapGetters } from 'vuex'
import EpaSidebar from '@/components/EpaSidebar'
import c3 from 'c3'

export default {
  name: 'epa-report',
  components: {
    Loader,
    InputField,
    EpaSidebar,
    Tooltip,
    ContactModal,
    Modal,
    Alert,
    BarLoader,
    GenerateTimeChart,
    SimulationTimeChart,
    MonthYieldChart,
    ProfitChart
  },
  data () {
    return {
      isRender: false,
      loaderActive: false,
      isFixed: false,
      isSearch: false,
      titleEdit: false,
      writerEdit: false,
      sidebarActive: false,
      contactMessage: '',
      data: {
        id: '',
        pp_id: '',
        pp_pw: '',
        name: '',
        dr_capacity: '',
        dr_payment_rate: '',
        dr_winning_rate: '',
        dr_specific_date: '',
        target_peak: '',
        workingDayHourUsage: {
          min: '',
          max: '',
          avg: ''
        },
        drWorkingDayHourUsage: {
          min: '',
          max: '',
          avg: ''
        },
        expectedProfit: {
          base: 0,
          performance: 0
        },
        bid: {
          totalBid: 0,
          maxFilled: 0,
          maxProfit: 0,
          minFilled: 0,
          minProfit: 0,
          cutAmount: 0,
          cutHour: 0
        },
        rrmse: {
          max45: 0,
          mid610: 0,
          result: ''
        }
      },
      leftSideBarData: {},
      couponModal: {
        id: 'couponModal',
        type: 'confirm',
        title: '알림',
        size: 'modal-sm',
        fields: [
          {
            type: 'message',
            message: ['무료 쿠폰 증정 이벤트를 확인합니다.', '공지사항 페이지로 이동하시겠습니까?'],
            class: 'text-center'
          }
        ]
      },
      pricingModal: {
        id: 'pricingModal',
        type: 'confirm',
        title: '알림',
        size: 'modal-sm',
        fields: [
          {
            type: 'message',
            message: ['이용권 안내 페이지로 이동하시겠습니까?'],
            class: 'text-center'
          }
        ]
      },
      notifyModal: {
        id: 'notifyModal',
        type: 'alert',
        title: '알림',
        size: 'modal-sm',
        fields: [
          {
            type: 'message',
            message: [],
            class: 'text-center'
          }
        ]
      },
      saveModal: {
        id: 'saveModal',
        type: 'confirm',
        title: '',
        param: '',
        size: 'modal-sm',
        fields: []
      }
    }
  },
  watch: {
    'user': {
      handler: function (val) {
        /**
         * 페이지에 들어온 상태에서 새로고침 시
         * 페이지 초기화 시점보다 유저정보 업데이트 시점이 느리다.
         * 따라서 watch를 통해 user 정보가 업데이트 되는 시점에 권한체크 로직을 수행시킨다.
         */

        if (typeof val.id !== 'undefined') {
          this.$store.dispatch('checkAccessMenu').then(() => { this.init() })
        }
      }
    },
    sidebarActive: _.debounce(() => {
      /**
       * 현재 스크린 사이즈가 1200px 초과 1665 미만 일 경우에만 실행
       * 해당 스크린 사이즈에선 LeftSidebar 활성화 여부에 따라 그래프 레이아웃이 깨지기 때문에
       * 강제로 window resize 이벤트를 발생시켜 c3 차트를 다시 그리게 한다.
       */

      const minWidth = 1199
      const maxWidth = 1665
      const currentWidth = $('body').innerWidth()

      if (minWidth < currentWidth && currentWidth < maxWidth) {
        window.dispatchEvent(new Event('resize'))
      }
    }, 500)
  },
  computed: {
    ...mapGetters({
      user: 'user',
      condition: 'condition',
      isPaidMember: 'isPaidMember'
    }),
    bodyClass () {
      return this.isFixed ? ['preview-body', 'margin-header'] : ['preview-body']
    },
    hasAuthReport () {
      return this.isWriter && this.isPaidMember
    },
    headerClass () {
      return this.isFixed ? ['preview-header', 'container', 'header-fixed'] : ['preview-header', 'container']
    },
    isNewReport () {
      // 신규 보고서인지 구분한다. (보고서 ID 유무)
      const data = this.data
      const isNewReport = typeof data.reg_by === 'undefined'

      return isNewReport
    },
    isWriter () {
      // 보고서 작성자와 로그인한 사용자가 동일한지 확인한다.
      return this.data.reg_by === this.user.id
    }
  },
  methods: {
    ...mapActions([
      'showToastMessage',
      'getPricingInfo'
    ]),
    init () {
      // URL 파라미터가 없을 경우 비정상적인 접근으로 판단하여 리다이렉트한다.
      const params = this.$route.params
      if ($.isEmptyObject(params)) {
        this.$router.push({name: 'epa'})
        return
      }
      this.getReport(params.id)
    },
    initLoadReport (response) {
      // 현재 페이지에 데이터와 저장된 데이터를 병합하여 데이터를 초기화 해준다.
      const vm = this
      vm.data = {
        ...vm.data,
        ...response
      }
      vm.processData(vm.data)
      vm.leftSideBarData = {
        id: vm.data.id,
        pp_id: vm.data.pp_id,
        pp_pw: vm.data.pp_pw,
        pp_start: vm.data.pp_start,
        pp_end: vm.data.pp_end,
        name: vm.data.name,
        dr_capacity: vm.data.dr_capacity,
        dr_payment_rate: vm.data.dr_payment_rate,
        dr_winning_rate: vm.data.dr_winning_rate,
        specific_date: vm.data.specific_date,
        target_peak: vm.data.target_peak
      }
      vm.drawChart()
      vm.$nextTick(() => {
        // 플래그 초기화
        vm.isRender = true
        vm.loaderActive = false
        vm.isFixed = false
        vm.isSearch = false
        vm.titleEdit = false

        // 보고서 미리보기 옵션이 활성화 되었을 경우, 미리보기 창을 연다.
        if (vm.$route.params.preview) {
          vm.openPreview()
        }

        // 스크린 사이즈가 PC 일 경우(1200px 이상), 수익조건 메뉴창을 연다.
        vm.sidebarActive = vm.checkScreenWidth()
      })
    },
    checkScreenWidth (width = 1199) {
      // 현재 스크린 width를 비교하여 Boolean 값 반환
      return window.innerWidth > width
    },
    setCondition (params) {
      const vm = this
      let redrawChart = false
      if (params.target_peak !== vm.target_peak) {
        redrawChart = true
      }
      vm.data = {
        ...vm.data,
        ...params
      }
      if (redrawChart) {
        vm.drawChart()
        vm.processData(vm.data)
      }
    },
    navigate (id) {
      const body = $('body')
      const el = $(`#${id}`)
      const innerWidth = body.innerWidth()

      // 현재 창의 크기에 따른 헤더의 높이를 계산하여 빼준다.
      let headerHeight = innerWidth > 991 ? 224 : 116
      let position = (body.scrollTop() + el.offset().top) - headerHeight

      if (el && typeof el !== 'undefined') {
        $('html,body').stop().animate({scrollTop: (position)}, 500)
      }
    },
    openPreview () {
      const reportId = this.data.id

      // 보고서 저장유무 확인
      if (reportId) {
        const preview = '/preview/' + reportId + '/?type=epa'
        const left = (screen.width / 2) - (1280 / 2)
        const top = (screen.height / 2) - (720 / 2)
        const open = window.open(preview, 'preview', 'menubar=0, resizable=0, width=1280, height=720, top=' + top + ', left=' + left)

        // 팝업이 차단되어 있을 경우, 알림창을 띄운다.
        if (open === null || typeof open === 'undefined' || open.screenLeft === 0) {
          // alert('팝업 차단이 설정되어 있습니다. ' +
          //   '\n차단기능을 해제(팝업허용)해주세요. ' +
          //   '\n팝업 차단이 되있을 경우 일부기능이 정상적으로 동작하지 않습니다.')
        }
      }
    },
    getReport (id) {
      this.isRender = false
      api.getEpaReport('S', id, response => {
        this.initLoadReport(response)
      })
    },
    submitReport () {
      const saveData = {
        id: this.data.id,
        pp_id: this.data.pp_id,
        pp_pw: this.data.pp_pw,
        name: this.data.name,
        dr_capacity: this.data.dr_capacity,
        dr_payment_rate: this.data.dr_payment_rate,
        dr_winning_rate: this.data.dr_winning_rate,
        specific_date: this.data.specific_date,
        target_peak: this.data.target_peak
      }
      api.saveEpaReport(saveData, saveResponse => {
        if (saveResponse.error) {
          const message = saveResponse.message ? `보고서 저장실패: ${saveResponse.message}` : '보고서 저장실패'
          this.showToastMessage(message)
        } else {
          this.showToastMessage('보고서 저장완료')
          this.openPreview()
          // 사용자 결제정보 업데이트
          this.getPricingInfo().catch(() => {
            this.showToastMessage('사용자 결제정보 업데이트 실패')
          })
        }
      })
    },
    scrollSpy () {
      // 화면이 활성화 상태일경우에만 이벤트 동작
      if (this.isRender) {
        const el = $(window)
        const scrollPosition = el.scrollTop()

        // 스크롤이 헤더에 위치했을 경우, 헤더 고정
        if (el && scrollPosition >= 320) {
          if (!this.isFixed) this.isFixed = true
        } else {
          if (this.isFixed) this.isFixed = false
        }
      }
    },
    showMenu (target = '') {
      this.$refs.leftSidebar.toggleMenu(target)
    },
    showContactModal (type = '') {
      let message = ''

      // 문의내용 초기화
      this.contactMessage = message

      // 문의하기 창 활성화
      this.$refs.contactModal.show()
    },
    showNotifyModal (message = []) {
      // 전달받은 알림 메세지를 설정 후 모달창 활성화
      this.notifyModal.fields[0].message = message
      this.$refs.notifyModal.show()
    },
    showChargeModal () {
      // Main.vue로 이벤트 전달
      eventHub.$emit('showChargeModal')
    },
    showSaveModal (type) {
      /**
       * 보고서 저장, 복사 시 알림창으로 사용자에게 컨펌받을 내용을 정의하는 함수입니다.
       * 보고서 저장 모달을 출력하기 전 유료 회원 여부와 데이터 요청 상태를 체크합니다.
       * 다른 사람이 생성 한 보고서 일 경우 저장을 하지않고 미리보기 창을 띄웁니다.
       * 본인이 생성 한 보고서 일 경우 기존 저장, 복사 알림창을 띄웁니다.
       */
      const vm = this

      // 유료사용자가 아닐 경우, 이용권 구매 알림을 띄운다.
      if (!vm.isPaidMember) {
        vm.showChargeModal()
        return false
      }

      // 이미 저장된 보고서에 로그인한 유저가 작성자가 아닐 경우, 저장 버튼 클릭 시 미리보기 창을 띄운다.
      const data = vm.data
      const isNewReport = typeof data.reg_by === 'undefined'
      const isCreator = data.reg_by === vm.user.id
      const isSave = type === 'save'

      if (!isNewReport && !isCreator && isSave) {
        vm.openPreview()
        return false
      }

      // 모달창에 출력할 내용을 설정한다
      if (type === 'copy') {
        vm.saveModal['param'] = 'copy'
        vm.saveModal['fields'] = [
          {
            id: 'name',
            name: '프로젝트명',
            type: 'text',
            class: 'margin-0',
            helpText: '새로운 프로젝트명을 입력하세요.'
          }
        ]
      } else {
        vm.saveModal['param'] = 'save'
        vm.saveModal['fields'] = [
          {
            type: 'message',
            message: ['보고서를 저장하시겠습니까?'],
            class: 'text-center'
          }
        ]
      }

      // 모달창 활성화
      vm.$refs.saveModal.show()
    },
    drawChart () {
      const vm = this
      var elecUsagePatternChartData = {
        bindto: '#elecUsagePatternChart',
        data: {
          'x': 'x',
          columns: [
            ['x'].concat(_.range(1, 25)),
            ['평일 최대값     '].concat(vm.data.usage_by_hour
              ? vm.data.usage_by_hour.map((usage) => {
                return usage.max
              }) : new Array(24).fill(0)),
            ['평일 평균값     '].concat(
              vm.data.usage_by_hour
                ? vm.data.usage_by_hour.map((usage) => {
                  return usage.avg
                }) : new Array(24).fill(1)
            ),
            ['평일 최소값'].concat(
              vm.data.usage_by_hour
                ? vm.data.usage_by_hour.map((usage) => {
                  return usage.min
                }) : new Array(24).fill(2)
            )
          ]
        },
        axis: {
          x: {
            type: 'category',
            label: {
              text: '(시간)'
            },
            tick: {
              fit: true,
              centered: true,
              multiline: false,
              length: 0,
              outer: false
            }
          },
          y: {
            label: {
              text: '(kWh)',
              position: 'inner-top'
            },
            tick: {
              format: function (d) {
                return vm.numberToCommaStr(d)
              },
              length: 0,
              outer: false
            }
          }
        },
        grid: {
          y: {
            show: true
          }
        },
        color: {
          pattern: ['#fab005', '#ff671b', '#40678f']
        },
        padding: {
          bottom: 24
        },
        legend: {
          padding: 8
        }
      }
      c3.generate(elecUsagePatternChartData)
      const sortedPeak = Object.assign([], vm.data.daily_peak ? vm.data.daily_peak : []).sort((a, b) => {
        return b.peak - a.peak
      }).map((peak) => {
        return peak.peak
      })
      var chartData = {
        bindto: '#peakElecChart',
        data: {
          x: 'x',
          columns: [
            ['x'].concat(vm.data.daily_peak ? vm.data.daily_peak.map((peak) => {
              return peak.date
            }) : []),
            ['사용량'].concat(vm.data.daily_peak ? vm.data.daily_peak.map((peak) => {
              return peak.peak
            }) : []),
            ['LDC'].concat(sortedPeak),
            ['요금적용전력'].concat(vm.data.daily_peak ? new Array(vm.data.daily_peak.length).fill(vm.data.customer_info.charge_peak) : []),
            ['목표전력'].concat(vm.data.daily_peak ? new Array(vm.data.daily_peak.length).fill(vm.data.target_peak) : [])
          ],
          types: {
            '사용량': 'area'
          }
        },
        point: {
          show: false
        },
        axis: {
          x: {
            type: 'timeseries',
            label: {
              text: '(월)'
            },
            tick: {
              fit: true,
              centered: true,
              multiline: false,
              length: 0,
              outer: false,
              format: '%Y-%m'
            }
          },
          y: {
            label: {
              text: '(kWh)',
              position: 'inner-top'
            },
            tick: {
              format: function (d) {
                return vm.numberToCommaStr(d)
              },
              length: 0,
              outer: false
            }
          }
        },
        grid: {
          y: {
            show: true
          }
        },
        color: {
          pattern: ['#40678f', '#ff671b', '#88e7ff', '#fab005']
        },
        padding: {
          bottom: 24
        },
        legend: {
          padding: 8
        }
      }
      c3.generate(chartData)
    },
    // numberToCommaStr (str, precision) {
    //   var num = Number(str)
    //   var PRECISION = typeof precision === 'number' ? precision : 2
    //   if (parseInt(num, 10) !== num) {
    //     num = num.toFixed(PRECISION)
    //   }
    //   if (num.toLocaleString) {
    //     return num.toLocaleString()
    //   }
    //   return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    // },
    // [SVCINT-71]
    numberToCommaStr (str, precision) {
      const num = Number(str)

      if (isNaN(parseInt(str))) {
        return ''
      }

      if (num.toLocaleString) {
        return num.toLocaleString()
      }

      let numStr = num + ''
      precision = (typeof precision === 'number') ? precision : 2

      if (parseInt(num, 10) !== num) {
        numStr = num.toFixed(precision)
      }

      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    processData (data) {
      const vm = this
      const IS_STANDARD_USER = data.customer_info.contract_power > 2000
      let DR_CAPACITY = 0
      const DR_PAYMENT_RATE = parseInt(data.dr_payment_rate, 10)
      const SMP = 80
      let processedData = {
        workingDayHourUsage: {
          min: Number.MAX_SAFE_INTEGER,
          max: Number.MIN_SAFE_INTEGER,
          avg: '',
          sum: 0,
          count: 0
        },
        drWorkingDayHourUsage: {
          min: Number.MAX_SAFE_INTEGER,
          max: Number.MIN_SAFE_INTEGER,
          avg: '',
          sum: 0,
          count: 0
        },
        expectedProfit: {
          base: 0,
          performance: 0,
          sum: 0
        },
        bid: {
          totalBid: 0,
          maxFilled: 0,
          maxProfit: 0,
          minFilled: 0,
          minProfit: 0,
          cutAmount: 0,
          cutHour: 0
        },
        rrmse: {
          mid610: 0,
          max45: 0,
          result: ''
        }
      }
      const workingHour = [10, 11, 12, 14, 15, 16, 17, 18, 19, 20]
      const drNonWorkingDayHourUsage = {
        avg: 0,
        sum: 0,
        count: 0
      }
      data.usage_by_hour.forEach((usage) => {
        if (usage.min < processedData.workingDayHourUsage.min) {
          processedData.workingDayHourUsage.min = usage.min
        }
        if (usage.max > processedData.workingDayHourUsage.max) {
          processedData.workingDayHourUsage.max = usage.max
        }
        processedData.workingDayHourUsage.sum += usage.sum
        processedData.workingDayHourUsage.count += usage.count
        if (workingHour.indexOf(usage.hour) > 0) {
          if (usage.min < processedData.drWorkingDayHourUsage.min) {
            processedData.drWorkingDayHourUsage.min = usage.min
          }
          if (usage.max > processedData.drWorkingDayHourUsage.max) {
            processedData.drWorkingDayHourUsage.max = usage.max
          }
          processedData.drWorkingDayHourUsage.sum += usage.sum
          processedData.drWorkingDayHourUsage.count += usage.count
        } else {
          drNonWorkingDayHourUsage.sum += usage.sum
          drNonWorkingDayHourUsage.count += usage.count
        }
      })
      processedData.workingDayHourUsage.avg = (processedData.workingDayHourUsage.sum / processedData.workingDayHourUsage.count).toFixed(2)
      processedData.drWorkingDayHourUsage.avg = (processedData.drWorkingDayHourUsage.sum / processedData.drWorkingDayHourUsage.count).toFixed(2)
      if (!data.dr_capacity || data.dr_capacity === 0) {
        processedData.dr_capacity = parseInt(processedData.drWorkingDayHourUsage.avg - (drNonWorkingDayHourUsage.sum / drNonWorkingDayHourUsage.count), 10)
        DR_CAPACITY = processedData.dr_capacity
      } else {
        DR_CAPACITY = parseInt(data.dr_capacity, 10)
      }
      let drPriceffsfSum = 0
      let drPriceSum = 0
      drPriceffsfSum = vm.data.dr_price.reduce((a, c) => {
        return a + (IS_STANDARD_USER ? c.standard_price / c.standard_ffsf - c.standard_price : c.medium_price / c.medium_ffsf - c.medium_price)
      }, 0)
      drPriceSum = vm.data.dr_price.reduce((a, c) => {
        return a + (IS_STANDARD_USER ? c.standard_price : c.medium_price)
      }, 0)

      data.bidding_by_hour.forEach((bid) => {
        processedData.bid.totalBid += bid.sum
      })
      processedData.bid.cutAmount = processedData.bid.totalBid * data.dr_winning_rate / 100
      processedData.bid.cutHour = Math.min(processedData.bid.cutAmount / DR_CAPACITY * 40, 40)
      processedData.bid.maxFilled = processedData.bid.totalBid
      processedData.bid.maxProfit = processedData.bid.maxFilled * SMP
      processedData.bid.minFilled = processedData.bid.cutAmount
      processedData.bid.minProfit = processedData.bid.minFilled * SMP

      processedData.expectedProfit.base = parseInt((drPriceSum * DR_CAPACITY * DR_PAYMENT_RATE / 100), 10)
      processedData.expectedProfit.performance = parseInt(drPriceffsfSum * DR_CAPACITY *
        Math.min(processedData.bid.cutAmount / DR_CAPACITY, 40) / 40 * DR_PAYMENT_RATE / 100, 10)

      processedData.expectedProfit.sum = processedData.expectedProfit.base + processedData.expectedProfit.performance

      processedData.usage_by_hour = vm.data.usage_by_hour.map((item) => {
        return {
          ...item,
          min: parseInt(item.min, 10),
          max: parseInt(item.max, 10),
          avg: parseInt(item.avg, 10),
          sum: parseInt(item.sum, 10)
        }
      })

      processedData.rrmse.max45 = vm.data.rrmse && vm.data.rrmse.max45 ? vm.data.rrmse.max45 : 0
      processedData.rrmse.mid610 = vm.data.rrmse && vm.data.rrmse.mid610 ? vm.data.rrmse.mid610 : 0
      processedData.rrmse.result = vm.data.rrmse.max45 <= 30 || vm.data.rrmse.mid610 ? '통과' : '불합격'

      vm.data = {
        ...vm.data,
        ...processedData
      }
    }
  },
  created () {
    /**
     * Vue 인스턴스 생성 후 실행되는 단계입니다.
     * 원클릭 사업검토 페이지 진입 시 localStorage에 jwt token 여부를 확인합니다.
     * 토큰이 없을 경우 로그인 화면으로 이동, 있을 경우 Token validation 합니다.
     * validation 실패할 경우 로그인화면으로 이동, 성공할 경우 페이지를 초기화 합니다.
     */

    const vm = this
    const token = localStorage.getItem('_t')

    if (token) {
      // 토큰 유효성 검증
      vm.$store.dispatch('inspectToken', token).then(() => {
        // 유저 로그인 상태가 활성화 일 경우, 사용자 권한을 체크한다.
        if (typeof vm.user.id !== 'undefined') {
          vm.$store.dispatch('checkAccessMenu').then(() => {
            // 페이지 접근 권한이 있는 사용자의 경우, 페이지 초기화
            vm.init()
          })
        }
      })
    } else {
      // 토큰이 없을 경우, 로그인 화면으로 이동
      vm.$router.push({name: 'login'})
      return false
    }
  },
  mounted () {
    // 헤더를 고정하는 스크롤 이벤트 등록
    $(window).scroll(this.scrollSpy)
    this.drawChart()
  },
  beforeDestroy () {
    // 헤더고정 스크롤 이벤트 제거
    $(window).unbind('scroll')
  }
}
</script>

<style lang="scss">
@import '~@/assets/css/components/chart';
</style>

<style lang="scss" scoped>
#epaReport {
  // 작성자
  #writer {
    .writer-box {
      overflow: hidden;
      padding: 0 8px;
      line-height: 32px;
      background-color: $hover-color;

      @media (max-width: 991px) { padding: 16px; }

      label {
        width: 40px;
        margin: 4px 0;
        font-weight: bold;
        color: $font-color;
      }
      input {
        width: calc(100% - 48px);
        font-size: 12px;
        text-align: center;
      }
      p {
        width: calc(100% - 48px);
        display: inline-block;
        margin: 4px 0 0 0;
        font-size: 12px;
        color: $font-color;
        text-align: center;
      }
      button {
        float: right;
        margin: 8px 0;
      }
    }
  }

  // Header
  .preview-header {
    padding: 24px 0;
    margin-bottom: 48px;
    background-color: $hzc-white;
    border-bottom: 1px solid $hzc-gray-04;
    overflow: hidden;
    z-index: 3;

    .title-box {
      position: relative;
      top: 12px;
      width: 50%;
      max-width: calc(100% - 350px);
      float: left;
    }

    .title-edit-box {
      position: relative;
      top: -4px;
      width: calc(100% - 32px);
      height: 32px;
      float: left;

      @media (max-width: 767px) {
        top: 0;
      }
    }

    .btn-box {
      width: 50%;
      min-width: 350px;
      margin-top: 8px;
      float: left;
    }

    .title-box, .btn-box {
      .date-tag { color: $hzc-gray-05; }
      .address-tag { color: $hzc-gray-06; }

      .project-title {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: -1px;
        color: $font-color;
        line-height: 32px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        float: left;
      }

      .hz-input-default {
        border: 1px solid $hzc-gray-04;
      }

      .glyphicon-pencil {
        top: 11px;
        color: #7a98b6;
        font-size: 12px;
        cursor: pointer;
        float: left;
      }
    }

    @media (max-width: 767px) {
      padding: 16px;

      .title-box {
        max-width: initial;
        top: initial;
        width: 100%;
      }
      .btn-box {
        display: none;
      }
    }
  }

  // Header fixed
  .header-fixed {
    position: fixed;
    top: 64px;
    @media (max-width: 767px) { width: 100%; }
  }

  // Preview contents
  .preview-body {
    table {
      min-width: 950px;
      overflow: auto;
      position: initial;

      .table-header {
        &:first-child {
          border-top: 2px solid black;
        }

        th {
          padding: 16px 8px;
          font-size: 12px;
          font-weight: 700;
          text-align: left;
          color: #343a40;
          border-top: 1px solid #868e96;
          border-bottom: 1px solid #868e96;
        }

        .title {
          width: 90px;
          position: relative;
          color: $hzc-gray-07;
          vertical-align: initial;
          padding: 16px 0 0 0;
          text-align: left;
          font-size: 16px;
          border-bottom: 1px solid $hzc-gray-04;

          a {
            position: absolute;
            left: 0;
            bottom: 16px;
          }
        }

        &.sub > th {
          border-top: 1px solid $hzc-gray-06;
        }
      }

      .table-content {
        td {
          padding: 16px 8px;
          font-size: 14px;
          text-align: left;
          color: $hzc-gray-08;
          border-bottom: 1px solid $hzc-gray-04;
        }

        .sub-header {
          font-size: 12px;
          font-weight: bold;
          color: $hzc-gray-07;
        }

        .empty {
          position: relative;
          padding: 80px 8px;
          text-align: center;
        }

        .data-loader {
          position: absolute;
          top: calc(50% - 34px);
          left: calc(50% - 32px);
          transform: translate(-50%, -50%);
        }

        .data-text {
          position: absolute;
          top: 50%;
          width: 100%;
          font-weight: bold;
          color: #868E97;
          z-index: 1;
        }
      }
    }

    @media (max-width: 767px) {
      padding: 0 16px;
    }

    &.margin-header {
      margin-top: 156px;
    }

    .card-wrap {
      .card-header {
        margin-bottom: 40px;

        .card-title {
          overflow: hidden;
          h4 {
            display: inline-block;
            float: left;
            margin: 0;
            font-size: 24px;
            font-weight: bold;
            color: #495057;
          }

          button {
            float: left;
            margin-left: 8px;
          }
        }
      }
      .card-content {
        height: auto;
        overflow-x: auto;

        .flexitem {
          min-height: 60px;
        }
      }

      .col-md-12 {
        padding: 0;
      }

      .col-xs-6,
      .col-xs-4 {
        &:first-child {
          padding-left: 0;
        }
      }
    }

    .additional-info {
      background-color: #f8f8f8;
      padding-left: 16px;
      color: #FF7133;
    }

    .have-child {
      height: auto;
      overflow: hidden;
    }
  }

  // Preview footer
  .preview-footer {
    padding: 48px 0;
    button {
      width: 152px;
      margin: 0 8px;
      @media (max-width: 767px) {
        margin: 8px 0;
        width: 100%;
      }
    }
  }

  // Sidebar active
  &.sidebar-active {
    // 스크린사이즈가 2065px 이상 일 경우, 별도에 레이이아웃 조정이 필요없다.
    @media (min-width: 1200px) and (max-width: 2065px) {
      .sidebar-wrap {
        width: 400px;
        height: 1px;
        float: left;
      }
      .preview-wrap {
        width: calc(100% - 400px);
        height: 100%;
        float: left;
      }
    }

    @media (min-width: 1200px) and (max-width: 1665px) {
      .preview-wrap {
        .preview-content {
          width: calc(100% - 96px);
        }
        .preview-header {
          width: 100%;
        }
        .header-fixed {
          width: calc(100% - 496px);
        }
      }
    }
  }

  // Contact FAB
  .contact-fab {
    .fab {
      position: fixed;
      right: 32px;
      bottom: 32px;
      width: 56px;
      height: 32px;
      border: none;
      border-radius: 4px;
      box-sizing: content-box;
      box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
      0 1px 18px 0 rgba(0, 0, 0, 0.12),
      0 3px 5px -1px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      outline: none;
      overflow: hidden;
      text-align: center;
      background-color: $primary-color-v2;
      color: $hzc-white;
      font-size: 12px;
      z-index: 2;

      &:hover {
        background-color: darken($primary-color-v2, 10%);
        color: $hzc-white;
      }
    }
    .fab-text {
      padding: 12px 0;
      text-decoration: none;
      font-weight: bold;
    }
  }

  // API Request state Alert UI
  .alert-wrap {
    width: 320px;
    position: fixed;
    top: 184px;
    right: 32px;
    z-index: 7;

    @media (max-width: 767px) {
      width: calc(100% - 16px);
      top: 72px;
      right: 8px;
    }
  }

  // Background Color
  .bg-dark-blue { background-color: #ebeff4; }
  .bg-light-gray { background-color: #f7f9fa; }
  .bg-light-blue { background-color: #edf2ff; }
  .bg-light-red { background-color: #ffe3d6; }

  // Font Color
  .font-dark-blue { color: #495057; }
  .font-primary { color: $primary-color-v2; }

  // Font Weight
  .font-weight-bold { font-weight: bold; }
  .font-weight-normal { font-weight: normal;}

  // Font Size
  .font-size-24 { font-size: 24px; }
  .font-size-16 { font-size: 16px; }
  .font-size-14 { font-size: 14px; }
  .font-size-12 { font-size: 12px; }

  // border
  .border-bottom-line {
    border-bottom: 1px solid #ced4da;
  }

  .m-b-120 {
    margin-bottom: 120px;
  }

  // epa specific
  .subtitle {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  .squarebullet::before {
    content: '\25FC ';
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/epa/EpaReport.vue